import { Icons } from '@agro-club/agroclub-shared'

export const countryFlags = {
  RU: Icons.IconFlagRussia,
  BY: Icons.IconFlagBy,
}
